export default "__VITE_ASSET__dbdaSDSo__"